<template>
  <Layout>
    <main>
      <section :class="$style['header']">
        <img :class="$style['logo']" :src="logo" />
        <h1
          v-if="termsTitle"
          v-color="colorFontHeading"
          v-font-style="fontDetailHeading"
          v-text="termsTitle"
          :class="$style['title']"
        />
      </section>
      <section :class="$style['body']">
        <p
          v-if="termsText"
          v-color="colorFontBody"
          v-font-style="fontDetailBody"
          v-text="termsText"
          :class="$style['text']"
        />
      </section>
    </main>
  </Layout>
</template>
<script>
import { mapGetters } from 'vuex'
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: appConfig.title,
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  computed: {
    ...mapGetters('contentful', [
      'colorFontBody',
      'colorFontHeading',
      'fontDetailBody',
      'fontDetailHeading',
      'logo',
      'termsText',
      'termsTitle',
    ]),
  },
}
</script>

<style lang="scss" module>
@import '@design';

.header {
  padding-top: 12px;
  height: 100%;

  .title {
    padding-top: 26px;
  }
}

.body {
  padding: 14px 16px;

  .text {
    text-align: left;
  }
}
</style>
